
import "./FeaturedCategories.css";

import CategoryRecyclerview from "../layout/ScrollView/CategoryRecyclerview";

const FeaturedCategories = ({ categories = [], onSelect }) => {
  return (
    <>
    <CategoryRecyclerview items={categories} onItemClick={onSelect}/>
      {/* <HorizontalRecyclerview
        items={categories}
        onItemClick={onSelect}
        renderItem={(cat) => (
          <div key={cat._id} className="category-item">
            <img
              className="category-icon"
              src={
                `${process.env.REACT_APP_API_BASE_URL}${cat.image}` ||
                "/images/default-category.png"
              }
            />
            <span className="category-name">{cat.name}</span>
          </div>
        )}
      /> */}
    </>
    // <div className="featured-categories">

    //   <HorizontalRecyclerview
    //     items={categories}
    //     onItemClick={onSelect}
    //     renderItem={(cat) => (
    //       <div className="category-item">
    //         <img
    //           src={
    //             `${process.env.REACT_APP_API_BASE_URL}${cat.image}` ||
    //             "/images/default-category.png"
    //           }
    //           alt={cat.name}
    //           className="category-icon"
    //         />
    //         <span className="category-name">{cat.name}</span>
    //       </div>
    //     )}
    //   >

    //   </HorizontalRecyclerview>
    // </div>
  );
};

export default FeaturedCategories;

//  <div className="featured-categories">
//       {categories.map((cat) => (

//       ))}
//     </div>
